import {Injectable, signal, computed, effect, Signal, WritableSignal} from "@angular/core";
import { PointVenteRepository } from "@galec/repositories";
import { PointVente } from "@models/pointVente.model";
import { DataCurrentIdMasterClientInterface } from "@interfaces/dataCurrentClientMaster.interface";

@Injectable({ providedIn: 'root' })
export class ClientMasterService {

    private _masters: WritableSignal<PointVente[]> = signal<PointVente[] | null>(null);

    private _currentIdMasterClient: WritableSignal<DataCurrentIdMasterClientInterface> = signal<DataCurrentIdMasterClientInterface | null>(null);

    public _currentMaster: Signal<PointVente> = computed<PointVente | undefined>((): PointVente => {

        const masters: PointVente[] = this._masters();
        const currentIdMasterClient: DataCurrentIdMasterClientInterface = this._currentIdMasterClient();

        if (!masters || masters.length === 0) {
            return undefined;
        }

        if (masters.length === 1) {
            return masters[0];
        }

        if (!currentIdMasterClient) {
            return masters[0];
        }

        const { codeActivite, numeroOrdre } = currentIdMasterClient;

        if (!codeActivite || numeroOrdre == null) {
            return masters[0];
        }

        return (masters.find((pointVente: PointVente): boolean => pointVente.activitecommerciale?.code_activite === codeActivite && pointVente.numero_ordre === numeroOrdre) ?? masters[0]);
    });

    private started: boolean = false;

    private showMastersList = signal(false);

    constructor(
        private readonly pointVenteRepository: PointVenteRepository
    ) {
        effect((): void => {

        });
    }

    public loadMasters(): void {
        if (this.started) return;
        this.started = true;
        this.pointVenteRepository.getMasters().subscribe({
            next: (response): void => {
                this._masters.set(response?.data?.pointvente ?? []);
            },
            error: (error): void => {
                console.error(`Une erreur est survenue lors de la récupération des Masters : ${error}`);
                this._masters.set([]);
                this.started = false;
            }
        });
    }

    public setCurrentIdMasterClient(data: DataCurrentIdMasterClientInterface): void {
        this._currentIdMasterClient.set(data);
    }

    public getMasters(): PointVente[] {
        return this._masters() ?? [];
    }

    public getCurrentMasterValue(): PointVente | undefined {
        return this._currentMaster();
    }

    public clear(): void {
        this.started = false;
        this.clearMasters();
        this.clearCurrentIdMasterClient();
    }

    public clearMasters(): void {
        this._masters.set(null);
    }

    public clearCurrentIdMasterClient(): void {
        this._currentIdMasterClient.set(null);
    }

    public getShowMastersList(): boolean {
        return this.showMastersList();
    }

    public setMastersListVisible(value: boolean): void {
        this.showMastersList.set(value);
    }

    public toggleMastersList(): void {
        this.showMastersList.update((value: boolean): boolean => !value);
    }
}
